import { render, staticRenderFns } from "./repayment.vue?vue&type=template&id=765a031d&scoped=true"
import script from "./repayment.vue?vue&type=script&lang=js"
export * from "./repayment.vue?vue&type=script&lang=js"
import style0 from "./repayment.vue?vue&type=style&index=0&id=765a031d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765a031d",
  null
  
)

export default component.exports